export enum EProductCosts {
  BLING = 'BLING',
  DSERS = 'DSERS',
}
